/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const storeConfig = `
    {
        storeConfig {
            secure_base_media_url
            secure_base_static_url
            customer_password_minimum_password_length
            customer_password_required_character_classes_number
            base_media_url
            base_static_url
            base_url
            base_currency_code
            code
            catalog_search_engine
            copyright
            catalog_default_sort_by
            category_url_suffix
            default_title
            default_keywords
            default_description
            default_display_currency_code
            header_logo_src
            head_shortcut_icon
            icube_pinlocation_gmap_key
            logo_alt
            logo_width
            logo_height
            store_name
            welcome
            timezone
            title_prefix
            title_suffix
            title_separator
            website_id
            weight_unit
            oauth_access_token_lifetime_customer
            payments_configuration
            shipments_configuration
            snap_client_key
            snap_is_production
            aw_blog_general_enabled
            pickup_store
            recaptcha_for_forgot_password
            recaptcha_for_customer_login
            recaptcha_for_create_new_account
            recaptcha_v2_invisible_public_key
            recaptcha_v2_public_key
            swiftoms_enable_vendor_portal
            swiftoms_vendor_registration_enable_create_store
            swiftoms_rma_request_return_type
            swiftoms_rma_request_package_condition
            swiftoms_rma_request_reason
            swiftoms_vendor_enable_registration
            swiftoms_vendor_registration_origin
            swiftoms_billing_service_info_url
            google_map_enabled
            multitenant_katalis_purchase_credit_url
            swiftoms_vendor_beneficiaries
        }
    }
`;

export const availableStores = gql(`
query AvailableStores {
    availableStores {
        store_code
        store_name
        locale
        is_default_store
    }
}`);
